import { Link } from "react-router-dom";

export function FeatureItem({ icon, children, to }) {
  const className = "group flex items-center justify-between gap-3 py-2 text-sm font-semibold text-brand-ink";
  const body = (
    <>
      <span className="flex items-center gap-3">
        <span className="text-brand-blue">{icon}</span>
        {children}
      </span>
      <span className="text-slate-400 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true">→</span>
    </>
  );
  if (to) return <Link to={to} className={className}>{body}</Link>;
  return <div className={className}>{body}</div>;
}
